import { PageContent } from '@reapitform/dashboard-ui'
import { elPy9, Table, TTableRowAction } from '@reapitform/common-ui'
import { specialTermsTableConfig } from './special-conditions-table-config'
import { useState } from 'react'
import { FlexContainer, TextBase } from '@reapit/elements'
import { IDefaultSpecialTerms } from '../../../../api/types'
import { useDefaultSpecialCondition } from '../../../../api/defaults/special-terms'
import { AddSpecialCondition } from './modal/add-special-conditions'
import { UpdateSpecialConditionsModal } from './modal/update-special-conditions'
import { DeleteConfirmationModal } from './modal/delete-confirmation'
import { useSearchParams } from 'react-router-dom'

export const SpecialConditionTabContent: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState<boolean>(false)
  const [isOpenUpdateFormModal, setIsOpenUpdateFormModal] = useState<boolean>(false)
  const [isOpenAddFormModal, setIsOpenAddFormModal] = useState<boolean>(false)
  const [selectedData, setSelectedData] = useState<IDefaultSpecialTerms>()

  const { data, loading, errorString, updateCacheData } = useDefaultSpecialCondition({
    sortBy: searchParams.get('sortBy'),
    sortByDirection: searchParams.get('sortByDirection'),
  })

  const handleSortChanges = (key: string, order: 'asc' | 'desc') => {
    setSearchParams((params) => {
      params.set('sortBy', key)
      params.set('sortByDirection', order === 'asc' ? 'Ascending' : 'Descending')
      return params
    })
  }

  const rowActions: TTableRowAction<IDefaultSpecialTerms>[] = [
    {
      actionTitle: 'Edit',
      onClick: (data) => {
        setSelectedData(data)
        setIsOpenUpdateFormModal(true)
      },
    },
    {
      actionTitle: 'Delete',
      onClick: (data) => {
        setSelectedData(data)
        setIsOpenDeleteConfirmation(true)
      },
    },
  ]

  return (
    <PageContent className={elPy9}>
      <FlexContainer isFlexColumn>
        <TextBase hasSectionMargin>{specialTermsTableConfig.description}</TextBase>
        <Table
          headers={specialTermsTableConfig.header}
          rows={data}
          isLoading={loading}
          rowKeyIdentifier="id"
          errorMessage={errorString}
          emptyMessage={specialTermsTableConfig.emptyMessages}
          tableDataCountMessage={specialTermsTableConfig.countDisplay}
          onReorder={handleSortChanges}
          tableRowAction={rowActions}
          tableAction={{
            actionTitle: 'Create New',
            onClick: () => setIsOpenAddFormModal(true),
          }}
        />
      </FlexContainer>

      <AddSpecialCondition
        isOpen={isOpenAddFormModal}
        onOpenChange={(isOpen) => setIsOpenAddFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <UpdateSpecialConditionsModal
        defaultValues={selectedData}
        isOpen={isOpenUpdateFormModal}
        onOpenChange={(isOpen) => setIsOpenUpdateFormModal(isOpen)}
        refreshList={updateCacheData}
      />
      <DeleteConfirmationModal
        data={selectedData}
        isOpen={isOpenDeleteConfirmation}
        onOpenChange={(isOpen) => setIsOpenDeleteConfirmation(isOpen)}
        refreshList={updateCacheData}
      />
    </PageContent>
  )
}
